module.exports = __webpack_public_path__ + "img/more-circle.69569e7c.svg";